"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transition = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const Transition = exports.Transition = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const theme = (0, _material.useTheme)();
  const {
    drawer,
    ...otherProps
  } = props;
  const isMobile = (0, _material.useMediaQuery)(theme.breakpoints.down('sm'), {
    noSsr: true
  });
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Slide, {
      ref: ref,
      direction: "up",
      ...otherProps
    });
  }
  if (drawer) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Slide, {
      ref: ref,
      direction: "left",
      ...otherProps
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Fade, {
    ref: ref,
    ...otherProps
  });
});
